'use strict';

var withStyles = require('../../Styles/withStyles.js');
var FlatInput = require('./FlatInput.js');
var colorManipulator = require('../../../node_modules/@material-ui/core/esm/styles/colorManipulator.js');

var FilledFlatInput = withStyles["default"](function (theme) {
  return {
    root: {
      background: colorManipulator.fade(theme.palette.secondary.main, 0.08),
      color: theme.palette.black.primary
    }
  };
})(FlatInput);

module.exports = FilledFlatInput;
